import getCookieDomain from './getCookieDomain';

/**
 * Returns default cookie domain
 * @param context
 * @returns
 */
function getDefaultCookieDomain(context) {
  return getCookieDomain(undefined, context);
}
export default getDefaultCookieDomain;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/cookies/getDefaultCookieDomain.js
// module id = 2342
// module chunks = 11